import { render, staticRenderFns } from "./Diagnostics.vue?vue&type=template&id=b0dbed72&scoped=true&"
import script from "./Diagnostics.vue?vue&type=script&lang=js&"
export * from "./Diagnostics.vue?vue&type=script&lang=js&"
import style0 from "./Diagnostics.vue?vue&type=style&index=0&id=b0dbed72&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dbed72",
  null
  
)

export default component.exports